import { Injectable } from "@angular/core";
import { FileLogger } from "@comunicare/comunicare-helper";
import { IAppError } from "@comunicare/comunicare-interfaces";
import { ExportApiService } from "./api/export-api.service";

@Injectable({
  providedIn: "root",
})
export class ExportService {
  constructor(private exportApiService: ExportApiService) {}

  public async exportAlerts(patientId: string, lang: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.exportApiService.exportAlerts(patientId, lang).subscribe(
        (blob) => {
          const url = URL.createObjectURL(blob);
          window.open(url);
          resolve();
        },
        (error: IAppError) => {
          FileLogger.error("ExportService", "exportAlerts", error);
          reject(error.message);
        }
      );
    });
  }
}
